import MotionHoc from "./MotionHoc"

const CalenderComponent = () => {
  return <h1>Calender</h1>
}

const Calender = MotionHoc(CalenderComponent)

export default Calender;